export function initSponsorshipOpportunities() {
  // DOM Elements
  const modal = document.getElementById("sponsorship-modal");
  const modalClose = document.getElementById("modal-close");
  const modalTitle = document.getElementById("modal-title");
  const modalAmount = document.getElementById("modal-amount");
  const modalFeatured = document.getElementById("modal-featured");
  const modalDescription = document.getElementById("modal-description");
  const modalNote = document.getElementById("modal-note");
  const featuredWrapper = document.getElementById("featured-wrapper");
  const modalPrev = document.getElementById("modal-prev");
  const modalNext = document.getElementById("modal-next");
  const prevTitle = document.getElementById("prev-title");
  const nextTitle = document.getElementById("next-title");
  const prevSection = document.getElementById("prev-section");
  const nextSection = document.getElementById("next-section");
  const modalGrid = document.getElementById("modal-grid");
  const modalContentWrapper = document.getElementById("modal-content-wrapper");
  const modalFooterNav = document.getElementById("modal-footer-nav");

  const searchInput = document.getElementById("sponsorship-search");
  const searchContainer = document.getElementById("search-container");
  const chipContainer = document.getElementById("search-chip-container");
  const chipText = document.getElementById("chip-text");
  const clearSearch = document.getElementById("clear-search");
  const resultsCount = document.getElementById("results-count");
  const noResultsMsg = document.getElementById("no-results-message");
  const cardsContainer = document.getElementById("sponsorship-cards");
  const loadingSpinner = document.getElementById("loadingSpinner");

  if (!resultsCount) return;

  let allDocs = [];
  let visibleCards = [];
  let currentIndex = -1;
  let debounceTimer;

  resultsCount.classList.add("hidden");

  // Make entire search container focus the input
  if (searchContainer && searchInput) {
    searchContainer.addEventListener("click", (e) => {
      if (e.target !== searchInput) searchInput.focus();
    });

    searchInput.addEventListener("focus", () =>
      searchContainer.classList.add("focused"),
    );
    searchInput.addEventListener("blur", () =>
      searchContainer.classList.remove("focused"),
    );
  }

  // Helpers
  function escapeHtml(str) {
    return (str || "").replace(
      /[&<>"']/g,
      (m) =>
        ({
          "&": "&amp;",
          "<": "&lt;",
          ">": "&gt;",
          '"': "&quot;",
          "'": "&#039;",
        })[m],
    );
  }

  function refreshVisibleCards() {
    visibleCards = Array.from(
      cardsContainer.querySelectorAll(
        ".sponsorship-card:not([style*='display: none'])",
      ),
    );
  }

  function showLoading() {
    loadingSpinner.classList.remove("hidden");
    cardsContainer.classList.add("hidden");
    noResultsMsg.classList.add("hidden");
    resultsCount.classList.add("hidden");
  }

  function hideLoading() {
    loadingSpinner.classList.add("hidden");
  }

  // Modal Functions
  function openModal(card) {
    currentIndex = visibleCards.indexOf(card);
    if (currentIndex === -1) return;

    modalTitle.textContent = card.dataset.title || "Sponsorship";
    modalAmount.textContent = card.dataset.amount || "";

    const hasDesc = card.dataset.hasDescription === "true";
    const hasNote = card.dataset.hasNote === "true";
    const hasImg = card.dataset.hasFeatured === "true";

    modalDescription.innerHTML = "";
    modalNote.innerHTML = "";
    modalFeatured.src = "";
    modalFeatured.classList.add("hidden");
    featuredWrapper.classList.add("hidden");
    modalNote.classList.add("hidden");
    modalGrid.classList.add("hidden");

    if (hasImg && card.dataset.featured?.trim()) {
      modalFeatured.src = card.dataset.featured;
      modalFeatured.classList.remove("hidden");
      featuredWrapper.classList.remove("hidden");
    }

    if (hasDesc && card.dataset.description?.trim()) {
      modalDescription.innerHTML = card.dataset.description;
    }

    if (hasNote && card.dataset.note?.trim()) {
      modalNote.innerHTML = card.dataset.note;
      modalNote.classList.remove("hidden");
    }

    const showGrid =
      !featuredWrapper.classList.contains("hidden") ||
      modalDescription.innerHTML.trim();

    modalGrid.classList.toggle("hidden", !showGrid);

    if (showGrid) {
      if (!featuredWrapper.classList.contains("hidden")) {
        modalGrid.classList.add("md:grid-cols-[21.5625rem_auto]");
        modalGrid.classList.remove("grid-cols-1");
        modalDescription.classList.add("md:pl-5", "lg:pl-9");
      } else {
        modalGrid.classList.add("grid-cols-1");
        modalGrid.classList.remove("md:grid-cols-[21.5625rem_auto]");
        modalDescription.classList.remove("md:pl-5", "lg:pl-9");
      }
    }

    const hasContent = showGrid || !modalNote.classList.contains("hidden");
    modalContentWrapper.classList.toggle("hidden", !hasContent);

    modal.classList.remove("hidden");
    updateNavigation();
  }

  function updateNavigation() {
    refreshVisibleCards();
    if (visibleCards.length <= 1) {
      modalFooterNav.classList.add("hidden");
      return;
    }
    modalFooterNav.classList.remove("hidden");

    const isFirst = currentIndex === 0;
    const isLast = currentIndex === visibleCards.length - 1;

    prevSection.classList.toggle("hidden", isFirst);
    nextSection.classList.toggle("hidden", isLast);

    if (!isFirst) {
      prevTitle.textContent =
        visibleCards[currentIndex - 1]?.dataset.title || "";
      modalPrev.disabled = false;
      prevSection.classList.toggle("col-span-2", isLast);
      prevSection.classList.toggle("prev-no-divider-when-full", isLast);
    } else {
      modalPrev.disabled = true;
    }

    if (!isLast) {
      nextTitle.textContent =
        visibleCards[currentIndex + 1]?.dataset.title || "";
      modalNext.disabled = false;
      nextSection.classList.toggle("col-span-2", isFirst);
    } else {
      modalNext.disabled = true;
    }
  }

  // Initial load
  async function loadAllItems() {
    showLoading();

    try {
      const url =
        `${envConfig.TYPESENSE_BASE_URL}:${envConfig.TYPESENSE_PORT}/collections/sponsorships/documents/search?` +
        new URLSearchParams({
          q: "*",
          query_by: "title,description,note,searchable_text",
          sort_by: "publish_date:desc",
          per_page: 50,
          page: 1,
          num_typos: 0,
        });

      const res = await fetch(url, {
        headers: { "X-TYPESENSE-API-KEY": envConfig.TYPESENSE_SEARCH_ONLY_KEY },
      });

      if (!res.ok) throw new Error(`HTTP ${res.status}`);

      const data = await res.json();
      allDocs = data.hits?.map((hit) => hit.document) || [];
      renderCards(allDocs);
    } catch (err) {
      console.error("Initial load failed:", err);
      cardsContainer.innerHTML =
        '<p class="text-center py-12 text-red-600">Could not load sponsorship opportunities.</p>';
    } finally {
      hideLoading();
    }
  }

  // Real-time search
  async function performSearch() {
    const query = searchInput.value.trim();

    if (!query) {
      renderCards(allDocs);
      chipContainer.classList.add("hidden");
      resultsCount.classList.add("hidden");
      noResultsMsg.classList.add("hidden");
      cardsContainer.classList.remove("hidden");
      hideLoading();
      return;
    }

    showLoading();

    try {
      const params = new URLSearchParams({
        q: query,
        query_by: "title,description,note,searchable_text",
        sort_by: "publish_date:desc",
        per_page: 50,
        page: 1,
        num_typos: 0,
        prefix: false,
        infix: "off",
        drop_tokens_threshold: 0,
      });

      const url =
        `${envConfig.TYPESENSE_BASE_URL}:${envConfig.TYPESENSE_PORT}/collections/sponsorships/documents/search?` +
        params.toString();

      const res = await fetch(url, {
        headers: { "X-TYPESENSE-API-KEY": envConfig.TYPESENSE_SEARCH_ONLY_KEY },
      });

      if (!res.ok) throw new Error(`Search failed: ${res.status}`);

      const data = await res.json();
      const results = data.hits?.map((hit) => hit.document) || [];

      renderCards(results);

      chipContainer.classList.remove("hidden");
      chipText.textContent = query;

      // This is the key change
      if (data.found > 0) {
        resultsCount.textContent = `${data.found} Result${data.found !== 1 ? "s" : ""}`;
        resultsCount.classList.remove("hidden");
        noResultsMsg.classList.add("hidden");
      } else {
        resultsCount.textContent = "0 Results";
        resultsCount.classList.remove("hidden");
        noResultsMsg.classList.remove("hidden");
      }
    } catch (err) {
      console.error("Search error:", err);
      cardsContainer.innerHTML =
        '<p class="text-center py-8 text-red-600">Search failed. Please try again.</p>';
      resultsCount.classList.add("hidden");
      noResultsMsg.classList.add("hidden");
    } finally {
      hideLoading();
    }
  }

  // Render Cards
  function renderCards(docs) {
    cardsContainer.innerHTML = "";

    if (!docs.length) {
      noResultsMsg.classList.remove("hidden");
      resultsCount.classList.add("hidden");
      cardsContainer.classList.add("hidden");
      return;
    }

    cardsContainer.classList.remove("hidden");
    noResultsMsg.classList.add("hidden");

    docs.forEach((doc, idx) => {
      const packages = doc.packages || [];
      const firstAmount = packages[0]?.amount || "";

      let packageHTML = "";
      if (packages.length) {
        const gridClass =
          packages.length >= 2
            ? "grid grid-cols-1 xsm:grid-cols-2 gap-2 xsm:gap-4 sm:gap-3 lg:gap-6"
            : "grid grid-cols-1";

        let items = "";
        packages.forEach((pkg, i) => {
          const border =
            i < packages.length - 1
              ? "xsm:pr-4 sm:pr-3 lg:pr-6 max-xsm:pb-2 max-xsm:border-b-[.0625rem] xsm:border-r-[.0625rem] border-brand-light-sky-blue"
              : "";

          items += `
            <div class="w-fit flex flex-col items-start justify-start gap-2 ${border}">
              ${pkg.amount ? `<h2 class="w-full text-h2 font-josefin text-brand-dark-red font-normal text-center xsm:text-start">${escapeHtml(pkg.amount)}</h2>` : ""}
              ${pkg.investment_type ? `<p class="w-full text-p1 font-neutraface text-brand-black font-normal text-center xsm:text-start">${escapeHtml(pkg.investment_type)}</p>` : ""}
            </div>
          `;
        });

        packageHTML = `
          <div class="w-full flex flex-col xsm:flex-row items-center justify-between gap-6">
            <div class="w-auto max-w-full ${gridClass}">${items}</div>
            <img class="w-12 h-12 object-contain object-center" src="${themeAssets.arrowIcon}" alt="arrow">
          </div>
        `;
      }

      const searchableText = [
        doc.title || "",
        doc.description || "",
        doc.note || "",
        ...packages.map((p) => `${p.amount || ""} ${p.investment_type || ""}`),
      ]
        .join(" ")
        .toLowerCase();

      const card = document.createElement("div");
      card.className =
        "w-full p-5 lg:px-8 lg:py-6 flex flex-col items-start gap-4 lg:gap-6 bg-brand-blue-gray transform transition-transform duration-300 ease-in-out hover:scale-[1.01] sponsorship-card cursor-pointer no-underline";
      card.dataset.postId = doc.id;
      card.dataset.index = idx;
      card.dataset.searchText = searchableText;
      card.dataset.title = doc.title || "";
      card.dataset.amount = firstAmount;
      card.dataset.hasDescription = !!doc.description?.trim();
      card.dataset.hasNote = !!doc.note?.trim();
      card.dataset.hasFeatured = !!doc.featured_image?.trim();
      card.dataset.description = doc.description || "";
      card.dataset.note = doc.note || "";
      card.dataset.featured = doc.featured_image || "";

      card.innerHTML = `
        <p class="w-full text-[1.5625rem] leading-[2.0625rem] font-semibold text-brand-dark-blue border-b border-brand-dark-sky-blue pb-2 card-title !my-0 text-center xsm:text-start">
          ${escapeHtml(doc.title || "Untitled")}
        </p>
        ${packageHTML}
      `;

      card.addEventListener("click", () => openModal(card));
      cardsContainer.appendChild(card);
    });

    refreshVisibleCards();
  }

  // Event Listeners
  function debouncedSearch() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(performSearch, 350);
  }

  searchInput.addEventListener("input", debouncedSearch);

  chipContainer.querySelector("img")?.addEventListener("click", () => {
    searchInput.value = "";
    performSearch();
  });

  clearSearch?.addEventListener("click", (e) => {
    e.preventDefault();
    searchInput.value = "";
    performSearch();
  });

  // Modal Events
  modalClose.addEventListener("click", () => modal.classList.add("hidden"));
  modal.addEventListener("click", (e) => {
    if (e.target === modal) modal.classList.add("hidden");
  });

  modalPrev.addEventListener("click", () => {
    if (currentIndex > 0) {
      currentIndex--;
      visibleCards[currentIndex]?.click();
    }
  });

  modalNext.addEventListener("click", () => {
    if (currentIndex < visibleCards.length - 1) {
      currentIndex++;
      visibleCards[currentIndex]?.click();
    }
  });

  // Start
  loadAllItems();
}
document.addEventListener("DOMContentLoaded", () => {
  initSponsorshipOpportunities();
});
